import { render, staticRenderFns } from "./AcknowledgeMessagesEdit.vue?vue&type=template&id=1c42a540&"
import script from "./AcknowledgeMessagesEdit.vue?vue&type=script&lang=js&"
export * from "./AcknowledgeMessagesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports